<template>
  <div class="content">
    <img src="@/assets/images/lexue.png" />
    <div class="text">
      本书配套视频将于图书上市后开始录制并陆续上线，目前还在建设中，敬请期待~
    </div>
    <div class="buttom" @click="home">返回首页逛逛</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {
    this.$router.replace({
      path: "/willingLearn/index/index",
    });
  },
  methods: {
    home() {
      this.$router.push({
        path: "/index",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  margin: 0 auto;
  width: 600px;
  .img {
    margin: 0 auto;
    width: 600px;
    height: 433px;
  }
  .text {
    margin-top: 36px;
    text-align: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .buttom {
    margin: 25px auto;
    height: 40px;
    line-height: 40px;
    width: 160px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    background: #2e9adb;
    border-radius: 6px;
    cursor: pointer;
  }
}
</style>